(function () {
  const root = document.querySelector('[data-pop-saved-portraits]');
  if (!root || root.dataset.initialized === 'true') return;
  const configElement = document.querySelector('[data-pop-saved-portraits-config]');
  let config = {};
  try { config = JSON.parse(configElement?.textContent || '{}'); } catch {}
  const avatars = root.querySelector('[data-pop-saved-portraits-avatars]');
  const count = root.querySelector('[data-pop-saved-portraits-count]');
  const openButton = root.querySelector('[data-pop-saved-portraits-open]');
  const dialog = root.querySelector('[data-pop-saved-portraits-dialog]');
  const closeButton = root.querySelector('[data-pop-saved-portraits-close]');
  const grid = root.querySelector('[data-pop-saved-portraits-grid]');
  const empty = root.querySelector('[data-pop-saved-portraits-empty]');
  if (!avatars || !count || !openButton || !dialog || !closeButton || !grid || !empty) return;
  root.dataset.initialized = 'true';

  const storageKeys = ['geminiTransformer.generatedFiles'];
  const productUrl = (value) => {
    try {
      const url = new URL(String(value || ''), window.location.origin);
      if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return '';
      url.search = '';
      url.hash = '';
      return url.toString();
    } catch { return ''; }
  };
  const imageUrl = (value) => {
    const raw = typeof value === 'string' ? value.trim() : '';
    if (!raw) return '';
    if (/^data:image\/(?:png|jpe?g|webp|gif|avif);base64,[a-z0-9+/=\s]+$/i.test(raw)) return raw.length <= 200000 ? raw : '';
    try {
      const url = new URL(raw, window.location.origin);
      return !url.username && !url.password && (url.protocol === 'https:' ||
        (url.protocol === 'http:' && url.origin === window.location.origin)) ? url.toString() : '';
    } catch { return ''; }
  };
  const products = new Map((Array.isArray(config.products) ? config.products : [])
    .filter(product => product && product.id && productUrl(product.url))
    .map(product => [String(product.id), { url: productUrl(product.url), title: String(product.title || '') }]));
  const defaultUrl = productUrl(config.defaultProductUrl);

  const readEntries = () => {
    let entries;
    try { entries = JSON.parse(window.localStorage.getItem(storageKeys[0]) || '[]'); } catch { return []; }
    if (!Array.isArray(entries)) return [];
    const byArtwork = new Map();
    entries.forEach((entry, sequence) => {
      if (!entry || typeof entry !== 'object') return;
      const artwork = imageUrl(entry.hostedUrl) || imageUrl(entry.portraitUrl);
      const displayUrl = imageUrl(entry.previewUrl) || imageUrl(entry.displayUrl) || imageUrl(entry.combinedUrl) || artwork;
      if (!displayUrl) return;
      const key = artwork || displayUrl;
      const previous = byArtwork.get(key);
      const merged = { ...previous, ...entry, displayUrl, sequence };
      for (const field of ['productId', 'productUrl', 'productTitle']) {
        if (!entry[field] && previous?.[field]) merged[field] = previous[field];
      }
      byArtwork.set(key, merged);
    });
    return [...byArtwork.values()].sort((a, b) =>
      ((Date.parse(b.createdAt) || 0) - (Date.parse(a.createdAt) || 0)) || b.sequence - a.sequence);
  };

  const portraitLink = (entry) => {
    const id = String(entry.productId || '');
    const product = products.get(id);
    const target = product?.url || productUrl(entry.productUrl) || (!id ? defaultUrl : '');
    if (!target) return null;
    const url = new URL(target);
    const savedId = String(entry.id || '').trim();
    const artwork = [entry.hostedUrl, entry.portraitUrl].find(value => imageUrl(value) && !String(value).startsWith('data:'));
    if (!savedId && !artwork) return null;
    if (savedId) url.searchParams.set('uk_saved', savedId);
    if (artwork) url.searchParams.set('uk_saved_url', String(artwork).trim());
    const previewTheme = new URLSearchParams(window.location.search).get('preview_theme_id');
    if (previewTheme && /^\d+$/.test(previewTheme)) url.searchParams.set('preview_theme_id', previewTheme);
    return { url: url.toString(), title: product?.title || String(entry.productTitle || '') };
  };

  const syncVisibility = () => {
    root.hidden = !readEntries().length;
    if (root.hidden && dialog.open) dialog.close();
  };
  const makeImage = (entry) => {
    const image = new Image();
    image.src = entry.displayUrl;
    image.alt = '';
    image.referrerPolicy = 'no-referrer';
    image.decoding = 'async';
    return image;
  };
  const render = () => {
    if (!root.isConnected) return;
    const entries = readEntries();
    const links = entries.map(portraitLink);
    const allResumable = links.every(Boolean);
    count.textContent = entries.length
      ? `${entries.length} ${entries.length === 1 ? 'design' : 'designs'} ${allResumable ? 'ready to finish' : 'saved'}`
      : 'No saved portraits yet';
    avatars.replaceChildren(...entries.slice(0, 3).map(entry => {
      const image = makeImage(entry);
      image.className = 'pop-saved-portraits__avatar';
      return image;
    }));
    avatars.hidden = !entries.length;
    grid.replaceChildren(...entries.map((entry, index) => {
      const link = links[index];
      const card = document.createElement(link ? 'a' : 'div');
      card.className = 'pop-saved-portraits__card';
      if (link) card.href = link.url;
      const image = makeImage(entry);
      image.loading = 'lazy';
      const label = document.createElement('span');
      label.className = 'pop-saved-portraits__card-label';
      label.textContent = link?.title || String(entry.productTitle || `Saved portrait ${index + 1}`);
      card.append(image, label);
      if (link) card.setAttribute('aria-label', `Continue ${label.textContent}`);
      else {
        const unavailable = document.createElement('small');
        unavailable.textContent = 'This style is no longer available';
        card.append(unavailable);
      }
      return card;
    }));
    grid.hidden = !entries.length;
    empty.hidden = Boolean(entries.length);
    const createLink = empty.querySelector('a');
    if (createLink && defaultUrl) createLink.href = defaultUrl;
    syncVisibility();
  };

  openButton.addEventListener('click', () => {
    render();
    if (root.hidden) return;
    const entries = readEntries();
    const singleLink = entries.length === 1 ? portraitLink(entries[0]) : null;
    if (singleLink) {
      window.location.assign(singleLink.url);
      return;
    }
    dialog.showModal();
    openButton.setAttribute('aria-expanded', 'true');
    document.body.classList.add('pop-saved-portraits-open');
  });
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    openButton.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('pop-saved-portraits-open');
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  document.addEventListener('uk:saved-portraits-change', render);
  window.addEventListener('storage', event => { if (event.key === null || storageKeys.includes(event.key)) render(); });
  window.addEventListener('pageshow', render);
  const main = document.querySelector('main');
  if (main) new MutationObserver(records => {
    if (records.some(record => record.type === 'childList' || record.target.matches?.('[data-uk-portrait], .gemini-transformer'))) syncVisibility();
  }).observe(main, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'data-view'] });

  // Follow the visible header edge so the strip remains visible as the page scrolls.
  const header = document.querySelector('.site-header') || document.querySelector('.header-section');
  let positionFrame = 0;
  let previousTop = -1;
  const position = () => {
    positionFrame = 0;
    const top = header && getComputedStyle(header).opacity !== '0' ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 0;
    if (top !== previousTop) {
      root.style.setProperty('--pop-saved-portraits-top', `${top}px`);
      previousTop = top;
    }
  };
  const schedulePosition = () => { if (!positionFrame) positionFrame = requestAnimationFrame(position); };
  window.addEventListener('scroll', schedulePosition, { passive: true });
  window.addEventListener('resize', schedulePosition);
  if (header && typeof ResizeObserver !== 'undefined') new ResizeObserver(schedulePosition).observe(header);
  position();
  render();
})();
